import project_thumbnail_01 from '../assets/images/work/norcat-lock-tag/thumbnail.webp';
import project_thumbnail_13 from '../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_thumbnail.webp';
import project_thumbnail_14 from '../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_thumbnail.webp';
import project_thumbnail_02 from '../assets/images/work/vale-hrp/Vale HRP_thumbnail.webp';
import project_thumbnail_03 from '../assets/images/work/fiar/FiAR_thumbnail.webp';
import project_thumbnail_04 from '../assets/images/work/opg-sim/OPG_thumbnail.webp';
import project_thumbnail_05 from '../assets/images/work/sn-nex/thumbnail.webp';
import project_thumbnail_06 from '../assets/images/work/vale-preop/Vale Pre-Op_thumbnail.webp';
import project_thumbnail_07 from '../assets/images/work/certifire/Certifire_thumbnail.webp';
import project_thumbnail_08 from '../assets/images/work/motor-control/Motor Control_thumbnail.webp';
import project_thumbnail_09 from '../assets/images/work/hoisting-rigging/H&R_thumbnail.webp';
import project_thumbnail_10 from '../assets/images/work/sn-cas/CAS_thumbnail.webp';
import project_thumbnail_11 from '../assets/images/work/ontario-mine-rescue/OMR_thumbnail.webp';
import project_thumbnail_12 from '../assets/images/work/nxr/NXR_thumbnail.webp';
import project_thumbnail_15 from '../assets/images/work/norcat-mine-experience/NORCATMineExperience_thumbnail.webp';
import project_thumbnail_16 from '../assets/images/work/nevada-gold-lock-tag/NevadaGoldLockTag_thumbnail.webp';

export const projectData = [
    {
        heading: 'Experiential Learning',
        description: 'NORCAT Underground Experience',
        name: 'NORCAT Underground Experience',
        namespan: 'NORCAT, 2026',
        image: project_thumbnail_15,
        alt: 'Thumbnail for the NORCAT Underground Experience',
        slug: 'norcat-underground-experience',
    },
    {
        heading: 'Experiential Training',
        description: 'Nevada Gold Lock and Tag Program',
        name: 'Nevada Gold Lock and Tag Program',
        namespan: 'Nevada Gold Corporation, 2026',
        image: project_thumbnail_16,
        alt: 'Thumbnail for the Nevada Gold Lock and Tag Program',
        slug: 'nevada-gold-lock-tag-program',
    },
    {
        heading: 'Experiential Training',
        description: 'Lock & Tag Program',
        name: 'Lock & Tag Program',
        namespan: 'NORCAT, 2026',
        image: project_thumbnail_01,
        alt: 'Thumbnail for the NORCAT Lock and Tag VR training project',
        slug: 'norcat-lock-tag',
    },
    {
        heading: 'Experiential Training',
        description: 'Vale HRP',
        name: 'Vale HRP',
        namespan: 'Vale North Atlantic, 2025',
        image: project_thumbnail_02,
        alt: 'Thumbnail for the Vale HRP VR training project',
        slug: 'vale-hrp',
    },
    {
        heading: 'Experiential Training',
        description: 'FiAR',
        name: 'FiAR',
        namespan: 'NORCAT, 2020-Present',
        image: project_thumbnail_03,
        alt: 'Thumbnail for the FiAR Fire Extinguisher Training product',
        slug: 'fiar',
    },
    {
        heading: 'Simulation Tool',
        description: 'OPG Incident Command',
        name: 'OPG Incident Command',
        namespan: 'Ontario Power Generation, 2025-Present',
        image: project_thumbnail_04,
        alt: 'Thumbnail for the OPG Incident Command simulation project',
        slug: 'opg-sim',
    },
    {
        heading: 'Product & Platform',
        description: 'Nature Exchange',
        name: 'Nature Exchange',
        namespan: 'Science North, 2025-2026',
        image: project_thumbnail_05,
        alt: 'Thumbnail for the Nature Exchange product and platform project',
        slug: 'sn-nex',
    },
    {
        heading: 'Experiential Training',
        description: 'Vale Pre-Op',
        name: 'Vale Pre-Op',
        namespan: 'Vale North Atlantic, 2021',
        image: project_thumbnail_06,
        alt: 'Thumbnail for the Vale Pre-Op VR training project',
        slug: 'vale-preop',
    },
    {
        heading: 'Experiential Training',
        description: 'CertiFire',
        name: 'CertiFire',
        namespan: 'ECAO, CertiFire, 2023-Present',
        image: project_thumbnail_07,
        alt: 'Thumbnail for the CertiFire experiential VR training project',
        slug: 'certifire',
    },
    {
        heading: 'Experiential Training',
        description: 'Motor Control',
        name: 'Motor Control',
        namespan: 'NETCO, 2024',
        image: project_thumbnail_08,
        alt: 'Thumbnail for the Motor Control experiential VR training project',
        slug: 'motor-control',
    },
    {
        heading: 'Experiential Training',
        description: 'Hoisting & Rigging',
        name: 'Hoisting & Rigging',
        namespan: 'NETCO, 2023',
        image: project_thumbnail_09,
        alt: 'Thumbnail for the Hoisting and Rigging experiential VR training project',
        slug: 'hoisting-rigging',
    },
    {
        heading: 'Interactive Installation',
        description: 'Climate Action Show',
        name: 'Climate Action Show',
        namespan: 'Science North, 2023',
        image: project_thumbnail_10,
        alt: 'Thumbnail for the Climate Action Show interactive installation project',
        slug: 'sn-cas',
    },
    {
        heading: 'Interactive Installation',
        description: 'Ontario Mine Rescue',
        name: 'Ontario Mine Rescue',
        namespan: 'Science North, Ontario Mine Rescue, 2019',
        image: project_thumbnail_11,
        alt: 'Thumbnail for the Ontario Mine Rescue interactive installation project',
        slug: 'ontario-mine-rescue',
    },
    {
        heading: 'Experiential Training',
        description: 'Agnico Eagle Experience',
        name: 'Agnico Eagle Experience',
        namespan: 'Agnico Eagle, 2026',
        image: project_thumbnail_14,
        alt: 'Thumbnail for the Agnico Eagle 360 experiential project',
        slug: 'agnico-eagle-experience',
    },
    {
        heading: 'Experiential Training',
        description: 'Industrial Hazard Recognition Program',
        name: 'Industrial Hazard Recognition Program',
        namespan: 'NORCAT (Internal), 2026',
        image: project_thumbnail_13,
        alt: 'Thumbnail for the Hazard Recognition Program experiential VR training project',
        slug: 'industrial-hazard-recognition-program',
    },
    {
        heading: 'Platform',
        description: 'NXR',
        name: 'NXR',
        namespan: 'NORCAT, 2017-Present',
        image: project_thumbnail_12,
        alt: 'Thumbnail for the NXR platform project',
        slug: 'norcat-nxr',
    },
];
